import React from 'react';
import CampaignMessages from '../components/CampaignMessages/CampaignMessages';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

export default function CaseCampaignMessages() {
    return (
        <AuthenticatedLayout title="Mensagens da Campanha" requireAdmin>
            <CampaignMessages />
        </AuthenticatedLayout>
    );
}
